













































import { Component, Vue , Prop} from "vue-property-decorator";


@Component({})
export default class SFIcon extends Vue {
   @Prop(String) readonly name; 

   fillColor = "#f00"
   fillBgColor = "#f1f2f8"
}
